import { isEqual, has } from 'lodash';

const editableMixin = Base => class extends Base {
  componentWillReceiveProps(nextProps, nextContext) {
    const errors = (nextProps.lineItem || null) && has(nextProps.lineItem || nextProps.levelerItem, 'errors') ?
    { ...nextProps.lineItem.errors } : {};
    if (nextContext.isEditable && !isEqual(this.state.errors, nextProps.lineItem)) {
      this.setState({ errors });
    } else if (!nextContext.isEditable && !isEqual(this.state, nextProps.lineItem)) {
      this.setState({ ...nextProps.lineItem, errors });
    }
  }

  sanatize = (attr, val) => {
    let value = has(val, 'target') ? val.target.value : val;
    if (attr === 'total') value = value ? parseFloat(value) : '';
    return value;
  }
};

export default editableMixin;



// WEBPACK FOOTER //
// ./client/app/shared/mixins/editable.js